// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"219":"54359b12fbc84af7","653":"d17974449084963d","715":"9ffdcd2fb42a3a1b","946":"e880a2e6b7bd91ed"}[chunkId] + ".js";
};